import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    fileList: [],
    fetching: false,
    error: null,
}


export default handleActions({
    [type.GET_SCAN_FOLDER_CONTENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.GET_SCAN_FOLDER_CONTENT_SUCCESS]: (state, action) => {
        const { fileList } = action.payload
        return {
            ...state,
            fileList,
            fetching: false,
        }
    },
    [type.GET_SCAN_FOLDER_CONTENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/transfer-drive-files/reducer.js